import {
  IconButton,
  ListItem,
  ListItemText,
  makeStyles,
} from '@material-ui/core'
import { CenterFocusStrongOutlined, ClearOutlined } from '@material-ui/icons'
import { UIRegionOfInterest } from '../../UIRegionOfInterest'
import LabelSelectionActions from '../../selectionPdf/actions/labelSelectionActions'
import ContentTypeSelectionActions from '../../selectionPdf/actions/viewTypeSelectionActions'
import { useSelectedColumnsContext } from '../../../../SelectedColumnsProvider'
import { RegionOfInterestColors } from '../../selectionPdf/pdfViewport/Colors'

type SelectedColumnRowProps = {
  markupIdx: number
  pageNumber: number
  regionsOfInterest: UIRegionOfInterest
  focusedRegionOfInterest: UIRegionOfInterest | null
  focusOnRegionOfInterest: (roi: UIRegionOfInterest | null) => void
}

const useStyles = makeStyles((theme) => ({
  title: {
    margin: theme.spacing(1),
    width: 100,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontWeight: 'bold',
  },
  rowContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
    marginBottom: theme.spacing(1), // space between rows
  },
  iconButton: {
    marginRight: theme.spacing(1), // spacing between the icon and text
  },
}))

export default function SelectedColumnRow({
  markupIdx,
  pageNumber,
  regionsOfInterest,
  focusedRegionOfInterest,
  focusOnRegionOfInterest,
}: SelectedColumnRowProps) {
  const classes = useStyles()
  const { updateRegionOfInterest, removeRegionFromPage } = useSelectedColumnsContext()
  const roiColor = RegionOfInterestColors[regionsOfInterest.label] || 'white'
  return (
    <ListItem className={classes.rowContainer} style={{ backgroundColor: `${roiColor}1A` }}>
      <IconButton
        color='secondary'
        size='small'
        onClick={() => removeRegionFromPage(pageNumber, regionsOfInterest.id)}
        className={classes.iconButton}
      >
        <ClearOutlined />
      </IconButton>
      <IconButton
        color="secondary"
        size="small"
        onClick={() =>
          focusedRegionOfInterest?.id === regionsOfInterest.id
            ? focusOnRegionOfInterest(null)
            : focusOnRegionOfInterest(regionsOfInterest)
        }
      >
        <CenterFocusStrongOutlined
          color={focusedRegionOfInterest?.id === regionsOfInterest.id ? 'primary' : 'secondary'}
        />
      </IconButton>
      <ListItemText
        primaryTypographyProps={{ noWrap: false }} 
        className={classes.title}
        primary={`Column #${markupIdx+1}`}
      />
      <LabelSelectionActions
        selectedLabel={regionsOfInterest.label}
        setSelectedLabel={(label) => 
          updateRegionOfInterest(pageNumber, regionsOfInterest.id, regionsOfInterest.regionContentType, label)}
      />
      <ContentTypeSelectionActions
        selectedContentTypes={regionsOfInterest.regionContentType}
        setContentTypes={(contentTypes) => 
          updateRegionOfInterest(pageNumber, regionsOfInterest.id, contentTypes, regionsOfInterest.label)}
      />
    </ListItem>
  )
}
